const step_up = {
    verify_your_identity: 'Verifica tu identidad',
    choose_method_description: 'Para continuar, confirma que eres tú con uno de los siguientes métodos.',
    password: 'Contraseña',
    password_description: 'Introduce la contraseña de tu cuenta',
    enter_password_description: 'Introduce la contraseña de tu cuenta para continuar.',
    enter_verification_code_description: 'Introduce el código de verificación enviado a {{identifier}}.',
    subject_proof_description: 'Para continuar, confirma que eres tú a través de una cuenta vinculada a la tuya. Después podrás configurar un método de verificación.',
    no_method_available: 'No hay ningún método de verificación disponible',
    no_method_available_description: 'Tu cuenta no tiene ningún método que pueda completar esta verificación. Ponte en contacto con tu administrador para obtener ayuda.',
};
export default Object.freeze(step_up);
